import React, { PureComponent } from 'react';
import { number, string } from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../../../../constants/colors';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import { Actions, Events } from '../analytics';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { isEmpty } from '../../../../../../core/util/empty';
export const FADE_TIMEOUT = 1000;

export const Root = styled.div.withConfig({ componentId: 'sc-6ah0dg-0' })``;

export const CopyContainer = styled.div.withConfig({ componentId: 'sc-6ah0dg-1' })`
  padding-bottom: 8px;
`;

export const Icon = styled.img.withConfig({ componentId: 'sc-6ah0dg-2' })`
  display: block;
  width: 100%;
  height: 124px;
`;

export const ImgContainer = styled.div.withConfig({ componentId: 'sc-6ah0dg-3' })`
  width: 240px;
  margin: 0 auto;
  height: 124px;
`;

export const H2 = styled.h2.withConfig({ componentId: 'sc-6ah0dg-4' })`
  color: ${colors.squid};
  font-size: ${fontSize.extraLarge};
  font-family: ${fontFamily.medium};
  margin-top: 10px;
`;

export const P = styled.p.withConfig({ componentId: 'sc-6ah0dg-5' })`
  color: ${colors.darkText};
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.book};
  letter-spacing: 0.33px;
  line-height: 28px;
`;

class Base extends PureComponent {
  static propTypes = {
    cardCount: number.isRequired,
    cardIndex: number.isRequired,
    cardName: string.isRequired,
    insuranceProfileId: string.isRequired,
    userProfileId: string.isRequired,
  };

  componentDidMount() {
    analyticsTrackEvent(Events.INSURANCE_TUTORIAL, {
      action: Actions.SHOW_TUTORIAL_CARD,
      ...this.getTrackingProps(),
    });
  }

  getCarrierNameTypeString = ({ carrier, planName, planType }: any) => {
    if (isEmpty(carrier) && isEmpty(planName) && isEmpty(planType)) return 'insurance';

    if (isEmpty(planName) && isEmpty(planType)) return carrier;
    if (isEmpty(carrier) && isEmpty(planType)) return planName;
    if (isEmpty(carrier) && isEmpty(planName)) return planType;

    if (isEmpty(carrier)) return `${planName} ${planType}`;
    if (isEmpty(planName)) return `${carrier} ${planType}`;
    if (isEmpty(planType)) return `${carrier} ${planName}`;

    return `${carrier}, ${planName} ${planType}`;
  };

  getTrackingProps = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'cardCount' does not exist on type 'Reado... Remove this comment to see the full error message
    const { cardCount, cardIndex, cardName, insuranceProfileId, userProfileId } = this.props;
    return {
      cardCount,
      cardIndex,
      cardName,
      insuranceProfileId,
      userProfileId,
    };
  };
}

export default Base;
